<template>
  <div class="card-page">
    <AppNavbar :options="options" :zIndex="999"> </AppNavbar>
    <img class="card-image" :src="imageData.bgImage" alt="" />
    <div class="fixed-container" v-if="!isVip">
      <div class="time-out-container">
        <span class="time-text">优惠还剩</span>
        <van-count-down
          :time="time"
          millisecond
          @finish="bindTimeFinish"
          ref="countdown"
        >
          <template #default="timeData">
            <span class="block">{{ timeData.hours | filterNum }}</span>
            <span class="colon">:</span>
            <span class="block">{{ timeData.minutes | filterNum }}</span>
            <span class="colon">:</span>
            <span class="block">{{ timeData.seconds | filterNum }}</span>
            <span class="colon">:</span>
            <span class="block">{{
              timeData.milliseconds | filterMilliseconds
            }}</span>
          </template>
        </van-count-down>
      </div>
      <div class="btn-container">
        <img class="btn-image" :src="imageData.buttonImage" alt="" />
        <div
          class="click-btn"
          @click="bindClickBtn"
          v-buried
          data-buried="BG_VIP_THNK_BUY"
          v-clickBuried
          data-click-buried="CLICKE_VIP_THNK_BUY"
        ></div>
        <!-- <div class="icon">历史最低价！</div> -->
      </div>
      <div class="agreement-container">
        <span class="check-box" @click="bindToggle">
          <span v-show="isAgreement" class="iconfont icon-gou"></span>
        </span>
        <span>我已阅读并同意</span>
        <span class="text" @click="bindToAgreement">会员服务协议</span>
      </div>
    </div>
    <van-popup v-model="showToast">
      <div class="toast-conttent">
        <div
          class="toast-close iconfont icon-cha"
          @click="showToast = false"
        ></div>
        <div class="toast-title">确认开通</div>
        <div class="toast-desc"
          >我已阅读并同意<span
            style="color: rgba(36, 199, 137, 1)"
            @click="bindToAgreement"
            >《会员服务协议》</span
          >，确认开通会员。</div
        >
        <div class="toast-btn" @click="bindToastConfirm">继续开通</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
import { PriceImageData } from './data.js'
export default {
  components: { AppNavbar },
  data() {
    return {
      priceImageData: PriceImageData,
      options: {
        barBackgroundColor: 'rgba(255,255,255,0)',
        color: 'rgba(0,0,0,0.8)'
      },
      isAgreement: false,
      showToast: false,
      repeatTime: 1000 * 60 * 30, //重复倒计时30分钟
      time: 0,
      isVip: false,
      loaded: false
    }
  },
  filters: {
    filterNum(num) {
      return num > 9 ? num : '0' + num
    },
    filterMilliseconds(num) {
      return Math.floor(num / 100)
    }
  },
  created() {
    this.init()
  },
  computed: {
    imageData() {
      let id = +this.$route.query.id || 1
      return this.priceImageData[id]
    }
  },
  methods: {
    init() {
      this.time = this.getTimeOut()
    },
    getTimeOut() {
      let firstTime = localStorage.getItem('vip-timeout-flag')
      if (!firstTime) {
        localStorage.setItem(
          'vip-timeout-flag',
          new Date().toLocaleString().replace(/-/g, '/')
        )
        return 30 * 1000 * 60
      }
      let now = new Date()
      let nowTimes = now.getTime()
      let firstTimeNum = new Date(firstTime).getTime()
      let halfHours = 1000 * 60 * 30
      let repeatTime = halfHours - ((nowTimes - firstTimeNum) % halfHours)
      return repeatTime
    },
    async getVipInfo() {
      let res = await this.$http
        .getBaseApp('api/v3/WeplusData/getUserWeplusIdentify', {})
        .catch(() => {})
      this.loaded = true
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.isVip = res.data.is_old_weplus || res.data.is_weplus
        } else {
          this.$toast(res.msg || '获取用户信息失败')
        }
      }
    },
    bindToggle() {
      this.isAgreement = !this.isAgreement
    },
    bindToAgreement() {
      let url =
        '/web?url=' +
        encodeURIComponent(location.origin + '/betterwe/vip-agreement')
      this.$betterwe.jumpRoute(url)
    },
    bindClickBtn() {
      if (!this.isAgreement) {
        this.showToast = true
        return
      }
      this.bindBuy()
    },
    async bindBuy() {
      let urlData = {
        test: '/ecShop?url=https%3A%2F%2Ftshoph5.gymcity.com.cn%2Fpages%2Fitem%2Fespier-detail%3FisFastBuy%3D1%26dtid%3D55%26id%3D1008691%26title%3D%E8%87%AA%E7%A0%94%E5%95%86%E5%9F%8E&isGetShopToken=1&isLogin=1',
        pro: '/ecShop?url=https%3A%2F%2Fshoph5.gymcity.com.cn%2Fpages%2Fitem%2Fespier-detail%3FisFastBuy%3D1%26dtid%3D55%26id%3D2131%26title%3D%E8%87%AA%E7%A0%94%E5%95%86%E5%9F%8E&isGetShopToken=1&isLogin=1'
      }
      let url = this.$http.curEv() == 'pro' ? urlData.pro : urlData.test
      await this.$betterwe.jumpRoute(url)
      this.$http.appBack()
      return
      let deviceInfo = await this.$betterwe.getAppDevicesInfo()
      let version = await this.$betterwe.getAppVersion().catch(() => {})
      //大于243版本并且是ios跳转苹果支付
      if (deviceInfo.brand == 'iPhone' && version >= 243) {
        let payObj = {
          test: {
            bwtGoodsId: '10031',
            appleProductId: 'weplus_yy_year_yanmai'
          },
          pro: {
            bwtGoodsId: '10031',
            appleProductId: 'weplus_yy_year_yanmai'
          }
        }
        let payData = this.$http.curEv() == 'pro' ? payObj.pro : payObj.test
        let payRes = await this.$betterwe.jumpApplePlaceOrder(
          payData.bwtGoodsId,
          payData.appleProductId
        )
        if (payRes && payRes.code == 0) {
          this.$http.appBack()
        }
      } else {
        let urlData = {
          test: '/ecShop?url=https%3A%2F%2Ftshoph5.gymcity.com.cn%2Fpages%2Fitem%2Fespier-detail%3FisFastBuy%3D1%26dtid%3D55%26id%3D1008691%26title%3D%E8%87%AA%E7%A0%94%E5%95%86%E5%9F%8E&isGetShopToken=1&isLogin=1',
          pro: '/ecShop?url=https%3A%2F%2Fshoph5.gymcity.com.cn%2Fpages%2Fitem%2Fespier-detail%3FisFastBuy%3D1%26dtid%3D55%26id%3D2131%26title%3D%E8%87%AA%E7%A0%94%E5%95%86%E5%9F%8E&isGetShopToken=1&isLogin=1'
        }
        let url = this.$http.curEv() == 'pro' ? urlData.pro : urlData.test
        await this.$betterwe.jumpRoute(url)
        this.$http.appBack()
      }
    },
    bindToastConfirm() {
      this.showToast = false
      this.bindToggle()
      setTimeout(() => {
        this.bindBuy()
      }, 300)
    },
    //倒计时结束
    bindTimeFinish() {
      console.log('倒计时结束')
      //重复30分钟
      this.time = this.getTimeOut()
      this.$refs.countdown.reset()
    }
  }
}
</script>
<style lang="scss" scoped>
.card-page {
  padding-bottom: 50px;
  background-color: rgba(255, 221, 148, 1);
  .card-image {
    width: 100%;
  }
  .fixed-container {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 14px 0px 33px;
    background: #fffaf2;
    .time-out-container {
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      font-size: 12px;
      color: #5e3814;
      line-height: 16px;
      .time-text {
        margin-right: 7px;
      }
      .colon {
        display: inline-block;
        margin: 0 4px;
        font-weight: bold;
        font-size: 14px;
        color: #4a3d6b;
        line-height: 20px;
      }
      .block {
        width: 20px;
        height: 20px;
        background: #5e3814;
        border-radius: 4px;
        display: inline-block;
        color: #fff;
        text-align: center;
        font-weight: bold;
        font-size: 12px;
        color: #ffffff;
      }
    }
    .btn-image {
      width: 100%;
      height: 77px;
    }
    .agreement-container {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.5);
      line-height: 16px;
      .text {
        margin-left: 4px;
      }
      .check-box {
        border-radius: 50%;
        border: 1px solid #aeaeae;
        width: 12px;
        height: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 5px;
        .iconfont {
          color: #5e3814;
          font-size: 10px;
          font-weight: bold;
        }
      }
    }
  }
  .toast-conttent {
    position: relative;
    text-align: center;
    width: 280px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 12px;
    padding: 24px 20px 20px;
    .toast-close {
      width: 30px;
      height: 30px;
      font-size: 18px;
      color: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 10px;
      right: 10px;
    }
    .toast-title {
      font-weight: bold;
      font-size: 18px;
      color: #303038;
      line-height: 26px;
      margin-bottom: 8px;
    }
    .toast-desc {
      text-align: left;
      font-size: 13px;
      color: rgba(48, 48, 56, 0.7);
      line-height: 21px;
      margin-bottom: 24px;
    }
    .toast-btn {
      text-align: center;
      height: 44px;
      line-height: 44px;
      background: linear-gradient(270deg, #373a56 0%, #565e7a 100%);
      border-radius: 22px;
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;
    }
  }
  .btn-container {
    position: relative;
    .click-btn {
      width: 344px;
      height: 58px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .icon {
      position: absolute;
      right: 42px;
      top: -1px;
      background: #ffe82d;
      line-height: 19px;
      border-radius: 13px 13px 13px 0px;
      border: 1px solid #ffffff;
      font-weight: bold;
      font-size: 12px;
      color: #5e3814;
      padding: 0px 4px 0px 8px;
    }
  }
  .van-popup {
    background-color: transparent;
  }
}
</style>
